import React, { useState, useEffect } from 'react';
import { Button, Checkbox, Form, Label } from 'semantic-ui-react'
import axios from 'axios';
import './style.css'
import "bootstrap/dist/css/bootstrap.min.css";
import ImageUpload from "../../components/ImageUpload";

export default function UpdatePhoto() {
	
    return (
	<>
    <div className="container">
      <div className="content">
        <ImageUpload index = {localStorage.getItem('maticnibrojlovca')} />
      </div>
    </div>
	</>
    )
}